import { useState, useEffect, useCallback } from "react"
import { getReports } from "../api";
import { parseReportFile } from "../utils/parseReportFile"
import { groupReportsIntoWeeks } from "../utils/groupReports"

/**
 * Fetches every report PDF via our backend's GET /drive/files, parses
 * each filename into a { weekOf, region, ... } report, and groups
 * them into weekly folders (newest first, newest = "current").
 */
export const useReports = () => {
  const [reportWeeks, setReportWeeks] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const load = useCallback(async () => {
    setLoading(true)
    setError(null)

    try {
      const response = await getReports();
      const files = response.data;

      const reports = files
        .map(parseReportFile)
        .filter(Boolean) // drop files that don't match the naming convention

      setReportWeeks(groupReportsIntoWeeks(reports))
    } catch (err) {
      console.error("[reports] Failed to load reports:", err)
      setError(err)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    load()
  }, [load])

  return { reportWeeks, loading, error, refetch: load }
}

export default useReports
